export default {
  Language: '中文',
  system: {
    homePage: {
      login: '登录',
      register: '注册',

    },
    headerMenu: {
      HomePage: "首页",
      ScientificData: "科学数据",
      PDSDataSet: "PDS卷集",
      WebGis: "WebGis",
      Moon: "月球",
      Mars: "火星",
      Planet: "行星",
      SampleMoon: "月球样品",
      SampleAsteroid: '小行星样品',
      LunarSample: "行星地名库",
      PopularScience: "科普教育",
      ResourceTools: "资源工具",
      AboutUs: "关于我们",
      PlanetaryDatabaseName: "行星地库名",
      extraterrestrial: "地外样品",
    },
    infoData: {
      lastNew: "最新动态",
      more: "更多",
      Roam: "月球",
      Lunar: "火星",
      MoonandPlanets: "全景漫游",
      PopularScience: "科普教育",

      RecentNews: "最新数据",
      DataRelease: "数据发布",
      TasksIntroduction: "任务介绍",
      OngoingNews: "动态新闻",
      LatestProduct: "最新成果",
      NoticeandAnnouncement: "通知公告",
      Other: "其他",
      ReleaseTime: "发布时间",
      PageViews: "浏览次数"
    },
    footData: {
      Name: "中国科学院国家天文台月球与深空探测科学应用中心",
      ContactUs: "联系我们",
      RecordNumber: "备案序号",
      WenbaoNetworkSecurityFilingNumber: "文保网安备案号"
    }
  }
};
